import { Backdrop } from '@material-ui/core'

import MenuButton from '../../components/MenuButton'
import Banner from '../../components/Banner'
import SignUp from '../../components/SignUp'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    backgroundColor: theme.palette.primary.main,
    padding: 0,
    overflow: 'scroll',
    display: 'block',
  },
  close: {
    position: 'absolute',
    top: 0,
    right: 1,
    width: 180,
    height: 120,
    textAlign: 'right',
    zIndex: 100,
    background:
      'linear-gradient( to left bottom, rgba(0, 0, 0, 1) 7%, rgba(0, 0, 0, 0.7) 15%, rgba(0, 0, 0, 0) 55%)',
  },
  signup: {
    marginTop: 10,
  },
  container: {
    display: 'flex',
    minHeight: '100%',
    alignItems: 'center',
  },
  gridContainer: {
    minHeight: '100%',
    margin: '70px 0',
  },
}))

const PreAction = ({ onClose }) => {
  const classes = useStyles()

  return (
    <Backdrop open classes={{ root: classes.backdrop }}>
      <div className={classes.close}>
        <MenuButton onClick={onClose} action="close" />
      </div>
      <Container disableGutters className={classes.container}>
        <Grid container direction="column" className={classes.gridContainer}>
          <Grid item>
            <Banner
              title="LEFT BEHIND"
              titleExtra="NO CHILD"
              preTitle="take action to demand:"
              noImage
            />
          </Grid>
          <Grid item className={classes.signup}>
            <SignUp standalone contrast onSuccess={onClose} onFail={null} />
          </Grid>
        </Grid>
      </Container>
    </Backdrop>
  )
}

export default PreAction
